/** Directive that marks content for projection into the right column of HxThreeColumnLayout. @directive */

import { Directive, input } from '@angular/core';

/** Marks content for right column projection via ng-content selector. Standalone with optional aria-label. */
@Directive({
  selector: '[hxThreeColumnRight]',
  standalone: true,
  host: {
    '[attr.aria-label]': 'ariaLabel()',
  },
})
export class HxThreeColumnRight {
  /** Optional ARIA label for right column (applied via host binding). */
  ariaLabel = input<string | undefined>();
}
